import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { IStatusRegisterApi } from "./base/statusRegisterApi";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";

const baseRoute: string = "StatusRegister";

export class StatusRegisterApi extends IStatusRegisterApi {
	getDomain(showPending: boolean = false): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: { showPending } });
	}

	getList(request: string): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/listAll`, { params: request });
	}
}
